// src/auth/usuariosRecordados.js
// Usuarios recordados en este dispositivo: SOLO nombres de usuario (nunca contraseñas).
// Se guarda en localStorage un arreglo de strings, el más reciente primero, máximo 10.

export const CLAVE_USUARIOS_RECORDADOS = 'usuarios_recordados';
export const MAX_USUARIOS_RECORDADOS = 10;
const CLAVE_ANTERIOR = 'remember_username'; // casilla "Recordar usuario" anterior

function limpiarLista(valor) {
  if (!Array.isArray(valor)) return [];
  const vistos = new Set();
  const lista = [];
  for (const v of valor) {
    if (typeof v !== 'string') continue;
    const u = v.trim();
    if (!u || vistos.has(u.toLowerCase())) continue;
    vistos.add(u.toLowerCase());
    lista.push(u);
  }
  return lista.slice(0, MAX_USUARIOS_RECORDADOS);
}

function escribir(lista) {
  try { localStorage.setItem(CLAVE_USUARIOS_RECORDADOS, JSON.stringify(lista)); } catch {}
  return lista;
}

export function leerUsuariosRecordados() {
  let lista = [];
  try { lista = limpiarLista(JSON.parse(localStorage.getItem(CLAVE_USUARIOS_RECORDADOS) || '[]')); } catch {}
  // Migra el único usuario que guardaba la versión anterior y elimina esa clave.
  try {
    const anterior = localStorage.getItem(CLAVE_ANTERIOR);
    if (anterior !== null) {
      localStorage.removeItem(CLAVE_ANTERIOR);
      lista = escribir(limpiarLista([...lista, anterior]));
    }
  } catch {}
  return lista;
}

/** Tras un inicio de sesión exitoso: lo pone primero, sin duplicados, y descarta el más antiguo si pasa de 10. */
export function recordarUsuario(username) {
  const u = String(username || '').trim();
  if (!u) return leerUsuariosRecordados();
  const resto = leerUsuariosRecordados().filter((x) => x.toLowerCase() !== u.toLowerCase());
  return escribir(limpiarLista([u, ...resto]));
}

/** Quita el usuario solo de este dispositivo (no toca la cuenta ni el servidor). */
export function olvidarUsuario(username) {
  return escribir(leerUsuariosRecordados().filter((x) => x !== username));
}
